import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import { Icon } from '@unite-us/ui';
import { getAddressString } from "./index";
var AddressText = function AddressText(_ref) {
  var address = _ref.address,
    iconStyle = _ref.iconStyle;
  if (isEmpty(address)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "address-text"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconMapMarker",
    style: iconStyle
  }), getAddressString(address));
};
AddressText.propTypes = {
  address: PropTypes.object,
  iconStyle: PropTypes.object
};
AddressText.defaultProps = {
  iconStyle: {
    svg: {
      height: '12px',
      width: '12px'
    }
  },
  address: null
};
export default AddressText;